import clsx from "clsx";
import React from "react";

interface SuffixFieldProps {
    suffix: string;
    className?: string;
    children: React.ReactNode;
    isError?: boolean;
}

export const SuffixField = ({ suffix, className, children, isError = false }: SuffixFieldProps) => {
    return (
        <div className="flex">
            <div className="relative flex flex-grow items-stretch">{children}</div>
            <div
                className={clsx(
                    "-ml-px relative inline-flex items-center rounded-r border border-gray-light bg-gray-lighter px-2 text-gray-darker",
                    isError && "border-danger",
                    className,
                )}
            >
                {suffix}
            </div>
        </div>
    );
};
